import { render } from "./PhoneFaultNotCharging.vue?vue&type=template&id=2c88a8d8"
import script from "./PhoneFaultNotCharging.vue?vue&type=script&lang=js"
export * from "./PhoneFaultNotCharging.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__